import { Component, computed, input, output } from '@angular/core';
import {
  GcAccordionComponent,
  GcDropdownButtonComponent,
  GcInputFieldComponent,
  GcListItem,
  GcListItemComponent,
  GcRadioButtonComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import {
  FiberDataInputValues,
  InputFieldLabel,
  fiberDataInputFields,
} from '../../../../../shared/installation-report-content-v2/splicing-and-measuring-content/fiber-data/fiber-data-entites';

const createSplitterPortValues = (): GcListItem[] =>
  Array.from({ length: 32 }, (_, index) => {
    const value = String(index + 1);
    return { id: value, label: value };
  });

@Component({
  selector: 'app-installation-report-fiber-data-form',
  imports: [
    GcAccordionComponent,
    GcTextComponent,
    GcRadioButtonComponent,
    GcInputFieldComponent,
    GcDropdownButtonComponent,
    GcListItemComponent,
    IpoTranslatePipe,
  ],
  templateUrl: './installation-report-fiber-data-form.component.html',
  styleUrl: './installation-report-fiber-data-form.component.scss',
})
export class InstallationReportFiberDataFormComponent {
  fiberData = input.required<FiberDataInputValues>();
  usesPanelCard = input(true);

  panelcardChanged = output<boolean>();
  fieldChanged = output<{ label: InputFieldLabel; value: string }>();

  readonly inputFields = fiberDataInputFields;
  readonly splitterPortValues: GcListItem[] = createSplitterPortValues();

  isFieldDisabled = computed<(undisableable?: boolean) => boolean>(() => {
    const following = this.usesPanelCard();
    return (undisableable?: boolean) => following && !undisableable;
  });

  onPanelcardChange(following: boolean) {
    if (following === this.usesPanelCard()) {
      return;
    }
    this.panelcardChanged.emit(following);
  }

  onFieldChange(label: InputFieldLabel, value: string) {
    this.fieldChanged.emit({ label, value });
  }
}
